module.exports = "pegasus_template/assets/themelp1/creative/101.png";